import { FamilyAnswerStatsDto } from '@families-link/shared';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { FamilyAnswerTableActions } from '../../components/families-responses-table/families-responses-actions.component';
import { FamilyAnswerTableHandlers } from '../../components/families-responses-table/families-responses-table.component';

const helper = createColumnHelper<FamilyAnswerStatsDto>();

export function useFamiliesResponsesTableColumns(
	handlers: FamilyAnswerTableHandlers
): ColumnDef<FamilyAnswerStatsDto, string>[] {
	const { onView } = handlers;
	const [t] = useTranslation();
	const location = useLocation();
	const isAdminRoute = location.pathname.startsWith('/admin');

	const result = useMemo(
		() => [
			helper.accessor('fullName', {
				header: t('surveys.question-answers.columns.full-name'),
				meta: {
					flex: 1,
				},
				cell: ({ getValue }) => getValue() || '-',
			}) as ColumnDef<FamilyAnswerStatsDto, string>,

			helper.accessor('phoneNumber', {
				header: t('surveys.question-answers.columns.phone-number'),
				meta: {
					flex: 1,
				},
				cell: ({ getValue }) => getValue() || '-',
			}) as ColumnDef<FamilyAnswerStatsDto, string>,
			helper.accessor('engagementTitle', {
				header: t('surveys.question-answers.columns.engagement-title'),
				meta: {
					flex: 1,
				},
				cell: ({ getValue }) => getValue() || '-',
			}) as ColumnDef<FamilyAnswerStatsDto, string>,
			helper.accessor('createdAt', {
				header: t('surveys.question-answers.columns.date'),
				meta: {
					flex: 1,
				},
				cell: ({ getValue }) => {
					const raw = getValue();
					return raw ? format(new Date(raw), 'MM.dd.yyyy') : '-';
				},
			}) as ColumnDef<FamilyAnswerStatsDto, string>,

			...(isAdminRoute
				? [
						helper.accessor('districtName', {
							header: t('surveys.question-answers.columns.district'),
							meta: {
								flex: 1,
							},
							cell: ({ getValue }) => getValue() || '-',
						}) as ColumnDef<FamilyAnswerStatsDto, string>,
				  ]
				: []),
			helper.display({
				id: 'actions',
				cell: (props) => <FamilyAnswerTableActions familyAnswer={props.row.original} onView={onView} />,
			}) as ColumnDef<FamilyAnswerStatsDto>,
		],
		[t, onView]
	);

	return result;
}
